/**
 * postMessageFilter
 *
 * Utility for filtering out noise postMessage events that should never
 * be processed or logged by the application:
 *   - Browser extension messages (React DevTools, Chrome/Firefox/Safari extensions)
 *   - Webpack HMR messages (webpackInvalid, webpackOk, webpackWarnings, etc.)
 */

/**
 * Returns true if the MessageEvent is tooling/infrastructure noise that
 * the application should silently ignore.
 */
export function isNoiseMessage(event: MessageEvent): boolean {
  try {
    const origin = String(event.origin || "").toLowerCase();

    // Browser extension origins
    if (
      origin.startsWith("chrome-extension://") ||
      origin.startsWith("moz-extension://") ||
      origin.startsWith("safari-extension://")
    ) {
      return true;
    }

    const d = event.data as any;
    if (!d) return false;

    if (typeof d === "object") {
      // Webpack HMR messages (webpackInvalid, webpackOk, webpackWarnings, webpackHash, etc.)
      if (typeof d.type === "string" && d.type.startsWith("webpack")) return true;

      // React DevTools object messages
      const src = String(d.source || "").toLowerCase();
      if (
        src.includes("react-devtools") ||
        src.includes("react_devtools") ||
        src.includes("reactdevtools")
      ) {
        return true;
      }
      if (d.__REACT_DEVTOOLS_GLOBAL_HOOK__) return true;
      if (
        Object.prototype.hasOwnProperty.call(d, "react_devtools") ||
        Object.prototype.hasOwnProperty.call(d, "reactDevtools") ||
        Object.prototype.hasOwnProperty.call(d, "react-devtools")
      ) {
        return true;
      }
      if (d.hello === true && src.includes("react-devtools")) return true;
    }

    // React DevTools string messages
    if (typeof d === "string") {
      const s = d.toLowerCase();
      if (
        s.includes("react-devtools") ||
        s.includes("__react_devtools__") ||
        s.includes("react_devtools")
      ) {
        return true;
      }
    }
  } catch {
    // ignore detection errors — fall through to normal handling
  }

  return false;
}
